import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import { ChevronDownIcon, ChevronUpIcon } from '../../../../../../global/icons/icons';
import { Popover } from '../../../../../../global/popover/popover';
import './page-selector-dropdown.scss';

export interface IPageSelectorOption {
    label: string;
    value: number;
}

interface IProps {
    prefix: React.ReactNode;
    selectedLabel: string;
    selectedLabelItalic?: boolean;
    options: IPageSelectorOption[];
    selectedValue: number | null;
    onChange: (value: number) => void;
    disabled?: boolean;
    className?: string;
}

export const PageSelectorDropdown: React.FC<IProps> = ({
    prefix, selectedLabel, selectedLabelItalic, options, selectedValue, onChange, disabled, className
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const triggerRef = useRef<HTMLDivElement>(null);

    const handleToggle = () => {
        if (!disabled) {
            setIsOpen(prev => !prev);
        }
    };

    const handleSelect = (value: number) => {
        onChange(value);
        setIsOpen(false);
    };

    return (
        <div
            ref={triggerRef}
            className={classnames('page-selector-dropdown', className, {
                'page-selector-dropdown--open': isOpen,
                'page-selector-dropdown--disabled': disabled,
            })}
            onClick={handleToggle}
        >
            <span className='page-selector-dropdown__prefix'>{prefix}</span>
            <span className={classnames('page-selector-dropdown__value', { 'page-selector-dropdown__value--italic': selectedLabelItalic })}>{selectedLabel}</span>
            {isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
            <Popover
                buttonRef={triggerRef}
                isOpen={isOpen}
                onClickOutside={() => setIsOpen(false)}
                align='start'
                padding={0}
                customWidth={triggerRef.current?.getBoundingClientRect().width}
            >
                <div className='page-selector-dropdown__options'>
                    {options.map(option => (
                        <div
                            key={option.value}
                            className={classnames('page-selector-dropdown__option', {
                                'page-selector-dropdown__option--selected': option.value === selectedValue,
                            })}
                            onClick={e => { e.stopPropagation(); handleSelect(option.value); }}
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
            </Popover>
        </div>
    );
};
